import FormConfig from "../formConfig.js";
import { fun_PostAction } from "@/api/index";
// 引入转译方法
import CaLock from "@/components/common/calock";
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
import TenderPictureinfor from "../../../components/tenderPictureinfor/index.vue";
import ContractProjectManagerChangeDetail from "../changeDateils/index.vue";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        recordId: null, // 记录表主键
        contractRecordDirectlyId: null, // 直接发包备案主键
        constructionNo: null, // 报建编号
        prjName: null, // 项目名称
        section: null, // 标段号
        tenderContent: null, // 招标内容
        tenderClassNumName: null, // 招标类别
        tenderTypeNumName: null, // 招标方式
        corpName: null, // 中标单位名称
        basicInfoId: null, // 中标单位名称编号
        personName: null, // 项目经理名称
        winningPrice: null, // 中标价（万元）
        state: null, // 状态
        stateName: null, // 状态名称
        regulators: null, // 区管代码
        tenderReference: null, // 招标编号
        constructorId: null, // 项目负责人编号
        lockNo: null, // 锁编号
        digitalSignature: null // 数字签名
      },
      // 表单错误
      errRules: {},
      // 表单配置
      formConfigList: FormConfig.configList(),
      // 页面类型
      controllerFlg: this.$route.query.controllerFlg,
      // 主键
      id: this.$route.query.id,
      // 企业类型
      unitFlag: this.$route.query.unitFlag,
      // 类型
      type: this.$route.query.type,
      // 全局加载
      fullLoading: null
    };
  },
  // 注册组件
  components: {
    CaLock, // CA锁
    AuditHistoryRecord, // 历史核验记录
    TenderPictureinfor, // 附件页面
    ContractProjectManagerChangeDetail // 直接发包变更
  },
  // 接收父组件传递的数据
  props: {},
  // 模板编译完成
  mounted() {
    // 打开loading
    this.loading = true;
    // 如果是直接发包项目负责人解锁
    if (this.type == "10") {
      // 获取详情信息
      this.fun_Details();
    } else {
      // 调用直接发包项目负责人变更
      this.$refs.contractProjectManagerChangeDetail.fun_Open();
    }
  },
  // 自定义方法
  methods: {
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 请求，获取结果集
      fun_PostAction("/contractProjectManager/unlockDetail", {
        id: this.id,
        unitFlag: this.unitFlag,
        controllerFlg: this.controllerFlg // 操作标志
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data;
          if (this.controllerFlg === "update") {
            this.form.state = "";
          }
          // 关闭loading
          this.loading = false;
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 回显字段
      this.form[i] = e;
    },
    /**
     * @description 提交
     * @author
     */
    fun_Submit(state) {
      // 开启弹窗
      this.$refs.caLock.dialogCalock = true;
      // 签名数据, 交易人名称和日期
      this.$refs.caLock.data =
        this.form.prjName +
        this.form.constructionNo +
        this.form.corpName +
        this.form.personName;
      // 状态
      this.$refs.caLock.state = state;
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature) {
      // ca弹窗关闭
      this.$refs.caLock.dialogCalock = false;
      // 状态赋值
      this.form.state = state;
      // 赋值锁编号
      this.form.lockNo = lockNo;
      // 赋值数字签名
      this.form.digitalSignature = digitalSignature;
      // 弹出询问confirm
      this.$confirm(
        "确定进行提交操作吗？提交后将不能修改信息，请谨慎操作！",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        // 打开遮罩
        this.fun_Loading();
        // 请求
        fun_PostAction("/contractProjectManager/saveOrUpdateUnlock", {
          ...this.form, // form表单数据
          unitFlag: this.unitFlag,
          controllerFlg: this.controllerFlg // 操作标志
        }).then(res => {
          // 解构res.data
          const { result, msg } = res.data;
          // 加载框取消
          this.fullLoading.close();
          // 解析后台返回的结果集，判断是否成功
          if (result) {
            // 操作成功
            this.$message.success(msg);
            // 返回一览
            this.fun_Back();
          } else {
            // 请求失败，弹出失败msg的消息提示
            this.$message.error(msg);
          }
          // 关闭loading
          this.loading = false;
        });
      });
    },
    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },
    /**
     * 附件上传
     */
    fun_GetPictureinfor() {
      // 打开弹窗
      this.$refs.tenderPictureinfor.dialogVisible = true;
      // 打开弹框时调用
      this.$refs.tenderPictureinfor.fun_GetOpen();
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      this.fullLoading = Loading.service({
        lock: true,
        text: "正在进行效验，请耐心等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    }
  }
};
